// extracted by mini-css-extract-plugin
export var contrastLow = "_39-1";
export var externalLink = "_39-2";
export var externalLinkIcon = "_39-3";
export var link = "_39-0";
export var linkLabel = "_39-4";